var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLegals(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.82634 5.98182C6.34949 5.2329 9.11309 3.76946 10.8698 2.71274C11.5632 2.29565 12.4368 2.29565 13.1302 2.71274C14.8869 3.76946 17.6505 5.2329 20.1737 5.98182C20.5564 6.09542 20.8521 6.40791 20.8971 6.80462C21.3977 11.2139 20.3083 19.4386 12.2781 21.9173C12.0992 21.9725 11.9008 21.9725 11.7219 21.9173C3.69171 19.4386 2.60229 11.2139 3.10286 6.80462C3.14789 6.40791 3.44359 6.09542 3.82634 5.98182Z",
    stroke: "#257FFC",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 12L10.75 14L15.75 10",
    stroke: "#257FFC",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLegals);
export default __webpack_public_path__ + "static/media/legals.db45a132.svg";
export { ForwardRef as ReactComponent };